<template>
  <div class="integrations-base">
    <page-header :title="name" :subtitle="subtitle" />
    <page-container class="integrations-base">
      <div class="text-center py-9" v-if="loading">
        <b-spinner variant="primary" />
      </div>
      <div class="row py-6" v-else>
        <div class="col-lg-6 mb-5" v-for="(opt, i) in options" :key="i">
          <integration-card :integration="opt" :newModal="newModal">
            <template #extra-buttons v-if="opt.name === 'enotas'">
              <div
                class="d-flex flex-column flex-lg-row justify-content-lg-end mt-5"
              >
                <bp-button
                  size="sm"
                  color="neutral"
                  variant="glyph"
                  label="Detalhes de notas fiscais"
                  trailing-icon="fa-regular fa-arrow-right"
                  @click="viewInvoices"
                />
              </div>
            </template>
          </integration-card>
        </div>
      </div>
    </page-container>
  </div>
</template>
<script>
import IntegrationCard from "./IntegrationCard.vue";
export default {
  components: { IntegrationCard },
  data() {
    return {
      name: "",
      subtitle: "",
      newModal: false,
      loading: false
    };
  },
  computed: {
    options() {
      return [];
    }
  },
  methods: {
    viewInvoices() {
      this.$router.push({ name: "tools-invoices-details" });
    }
  }
};
</script>
